<template>
  <div class="storage-chart-container" style="position: relative; height: 300px; width: 300px;">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import Chart from 'chart.js/auto';

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  options: {
    type: Object,
    default: () => ({})
  }
});

const chartCanvas = ref(null);
let chartInstance = null;

const createChart = () => {
  if (!chartCanvas.value || !props.data) return;
  
  // Destroy existing chart if it exists
  if (chartInstance) {
    chartInstance.destroy();
  }
  
  const ctx = chartCanvas.value.getContext('2d');
  
  chartInstance = new Chart(ctx, {
    type: 'doughnut',
    data: props.data,
    options: {
      ...props.options,
      responsive: true,
      maintainAspectRatio: false
    }
  });
};

watch(() => props.data, () => {
  createChart();
}, { deep: true });

watch(() => props.options, () => {
  createChart();
}, { deep: true });

onMounted(() => {
  createChart();
});

onUnmounted(() => {
  if (chartInstance) {
    chartInstance.destroy();
  }
});
</script>

<style scoped>
.storage-chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
